//   valid_session_time & session_expire_warning should be in second",

export const session = {
    'valid_session_time': 900,
    'session_expire_warning': 300
};
